import { render, staticRenderFns } from "./Bookmarks.vue?vue&type=template&id=d8488326&scoped=true&"
import script from "./Bookmarks.vue?vue&type=script&lang=js&"
export * from "./Bookmarks.vue?vue&type=script&lang=js&"
import style0 from "./Bookmarks.vue?vue&type=style&index=0&id=d8488326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8488326",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8488326')) {
      api.createRecord('d8488326', component.options)
    } else {
      api.reload('d8488326', component.options)
    }
    module.hot.accept("./Bookmarks.vue?vue&type=template&id=d8488326&scoped=true&", function () {
      api.rerender('d8488326', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/@core/layouts/components/app-navbar/components/Bookmarks.vue"
export default component.exports